import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global smooth momentum scrolling (Lenis).
 * Disabled for prefers-reduced-motion and touch.
 */
const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.2,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    // Expose lenis so route-level components can scroll it (e.g. reset on nav)
    window.__lenis = lenis;

    // Hijack same-page anchor clicks so smooth scrollIntoView still uses Lenis
    const onAnchorClick = (e) => {
      const link = e.target.closest("a[href^='#'], a[href*='/#']");
      if (!link) return;
      const href = link.getAttribute("href");
      const hash = href.startsWith("#") ? href : href.slice(href.indexOf("#"));
      const target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -80, duration: 1.2 });
    };
    document.addEventListener("click", onAnchorClick);

    return () => {
      document.removeEventListener("click", onAnchorClick);
      cancelAnimationFrame(rafId);
      if (window.__lenis === lenis) delete window.__lenis;
      lenis.destroy();
    };
  }, []);

  return children;
};

export default SmoothScroll;
